module.exports = __webpack_public_path__ + "img/logo.0777a7f0.png";